import { render, staticRenderFns } from "./PaywallTypesAndPricing.vue?vue&type=template&id=3d3f3b30"
import script from "./PaywallTypesAndPricing.vue?vue&type=script&lang=js"
export * from "./PaywallTypesAndPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports